"use client";

import Script from "next/script";

import useInteractionDeferred from "@/hooks/useInteractionDeferred";
import { env } from "@/env.mjs";

// ----------------------------------------------------------------------------

const MetricoolTrackerScript = () => {
  const ready = useInteractionDeferred();

  if (!env.NEXT_PUBLIC_ENABLE_PRODUCTION_FEATURES) return null;
  if (!ready) return null;

  return (
    <Script
      id="metricool-tracker"
      type="text/javascript"
      src="https://tracker.metricool.com/resources/be.js"
      strategy="lazyOnload"
      onLoad={() => {
        if (typeof window !== "undefined" && window.beTracker) {
          window.beTracker.t({ hash: "c8a0d326d274f1106c2da968bdc9c94d" });
        }
      }}
    />
  );
};

export default MetricoolTrackerScript;
